import { useEffect, useState } from 'react'
import { api } from './api.js'
import { applyTheme } from './theme.js'
import Home from './Home.jsx'
import Demarche from './Demarche.jsx'
import Suivi from './Suivi.jsx'

// Routage minimal : trois écrans, pas de dépendance de plus.
function route() {
  const p = window.location.pathname.replace(/\/$/, '')
  if (p.startsWith('/demarche/')) return { name: 'demarche', slug: p.split('/')[2] }
  if (p.startsWith('/suivi')) return { name: 'suivi' }
  return { name: 'home' }
}

export function navigate(path) {
  window.history.pushState({}, '', path)
  window.dispatchEvent(new PopStateEvent('popstate'))
}

export default function App() {
  const [site, setSite] = useState(null)
  const [erreur, setErreur] = useState('')
  const [page, setPage] = useState(route())

  useEffect(() => {
    const onPop = () => setPage(route())
    window.addEventListener('popstate', onPop)
    return () => window.removeEventListener('popstate', onPop)
  }, [])

  useEffect(() => {
    api.site().then((s) => {
      setSite(s)
      applyTheme(s.theme)
      document.title = `Vos démarches · ${s.org.name}`
    }).catch((e) => setErreur(e.message))
  }, [])

  if (erreur) return <main className="wrap"><p className="erreur">{erreur}</p></main>
  if (!site) return <main className="wrap"><p>Chargement…</p></main>

  return (
    <>
      <div className="tricolore" aria-hidden="true"><i /><i /><i /></div>
      <header className="nav">
        <div className="in">
          <a className="org" href="/" onClick={(e) => { e.preventDefault(); navigate('/') }}>
            <span className="logo">{site.theme.logo_text || site.org.name.slice(0, 2)}</span>
            <span>{site.org.name}</span>
          </a>
          <nav aria-label="Navigation principale">
            <a href="/" onClick={(e) => { e.preventDefault(); navigate('/') }}>Accueil</a>
            <a href="/suivi" onClick={(e) => { e.preventDefault(); navigate('/suivi') }}>Suivre ma demande</a>
          </nav>
        </div>
      </header>

      <main id="contenu">
        {page.name === 'home' && <Home site={site} />}
        {page.name === 'demarche' && <Demarche slug={page.slug} site={site} />}
        {page.name === 'suivi' && <Suivi site={site} />}
      </main>

      <footer className="pied">
        <div className="in">
          <span>{site.org.name}</span>
          <a href="/accessibilite">Accessibilité : partiellement conforme</a>
          <a href="/mentions-legales">Mentions légales</a>
          <a href="/donnees-personnelles">Données personnelles</a>
          <span className="signature">propulsé par UCIVIS</span>
        </div>
      </footer>
    </>
  )
}
